module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/posts/posts.component.scss
// module id = 584
// module chunks = 1